


































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { dom } from '@fortawesome/fontawesome-svg-core';
import { mapState } from 'vuex';
import moment from 'moment';
import comment from '@/components/CommentComponent.vue';
import PostCom from '@/components/CreatePostComponent.vue';
import * as firebase from 'firebase/app';
import User from '@/model/User';
import RoleType from '@/userManagement/RoleType';
import {
  COLLECTION_NOTIFICATIONS,
  COLLECTION_ORGANIZATIONS,
  COLLECTION_POSTS,
  COLLECTION_USERS,
} from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import PermUtil from '@/model/PermUtil';
import StatusType from '@/model/typelist/StatusType';
import Post from '@/model/Post';
import {
  Facebook,
  Twitter,
  Linkedin,
  WhatsApp,
} from 'vue-socialmedia-share';
import Notification from '@/model/Notification';
import NotificationType from '@/model/typelist/NotificationType';
import Edit from './EditPost.vue';

@Component({
  components: {
    comment,
    PostCom,
    Edit,
    Facebook,
    Twitter,
    Linkedin,
    WhatsApp,
  },
})
export default class HomePostView extends Vue {
  @Prop({ type: Array }) posts!: [];

  showComments = [] as any;

  editedIndex = -1;

  permUtil = new PermUtil();

  dialog = false;

  dialog1 = false;

  // dailog1 = false;

  showPost = false;

  editedPost = {};
  // eslint-disable-next-line
  postBg(post: any) {
    return `backgroundColor:${post.postTile.bgColor}`;
  }

  // eslint-disable-next-line class-methods-use-this
  viewUserCount(post: any) {
    if (!post.userViews.includes(this.currentUser.uid)) {
      const postObj = Post.convertToObj(post);
      postObj.id = post.id;
      postObj.createdBy = FirebaseUtil.ObjectToRef(
        COLLECTION_USERS,
        post.createdBy.uid,
      );
      const postCmts = [] as any;
      post.comments.forEach((cmt: any) => {
        const cmtObj = { ...cmt };
        cmtObj.createdTime = cmt.createdTime;
        cmtObj.createdBy = FirebaseUtil.ObjectToRef(
          COLLECTION_USERS,
          cmt.createdBy.uid,
        );
        cmtObj.text = cmt.text;
        postCmts.push(cmtObj);
      });
      postObj.comments = postCmts;
      // const postViewObj = Post.convertToObj(post);
      post.userViews.push(this.currentUser.uid);
      this.$store.dispatch('updateCollection', {
        collection: COLLECTION_POSTS,
        doc: post.id,
        payload: postObj,
      });
    };
  }
  // eslint-disable-next-line
  postFont(post: any) {
    return `fontFamily:${post.postTile.fontFamily}`;
  }

  editPost(post: any) {
    this.editPost = post;
    this.showPost = true;
  }
  // eslint-disable-next-line
  sharePost(id: any) {
    const url = `https://ineed-social.web.app/post/${id}`;
    return url;
  }

  // get showComp() {
  //   return this.permUtil.canCreateOwnPost(this.freshCurrentUser);
  // }
  // eslint-disable-next-line
  reportedPost(postObj: any, status: StatusType) {
    Post.updateStatus(postObj, status);
  }

  reportPost(post: any) {
    this.reportedPost(post, StatusType.reported);
    this.dialog1 = false;
  }

  // eslint-disable-next-line
  refMap(frnds: any[]) {
    return frnds.map((f: any) => FirebaseUtil.ObjectToRef(COLLECTION_USERS, f));
  }

  // eslint-disable-next-line
  orgRefMap(orgs: any[]) {
    return orgs.map((f: any) => FirebaseUtil.ObjectToRef(COLLECTION_ORGANIZATIONS, f));
  }

  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }

  get postReport() {
    return this.$store.state.reportPagePosts;
  }

  deletePost = (id: any) => {
    this.$store.dispatch('removeFromCollection', {
      collection: COLLECTION_POSTS,
      payload: id,
    });
    this.dialog = false;
  };

  likePost(post: any) {
    const postObj = Post.convertToObj(post);
    postObj.id = post.id;
    postObj.createdBy = FirebaseUtil.ObjectToRef(
      COLLECTION_USERS,
      post.createdBy.uid,
    );
    const postCmts = [] as any;
    post.comments.forEach((cmt: any) => {
      const cmtObj = { ...cmt };
      cmtObj.createdTime = cmt.createdTime;
      cmtObj.createdBy = FirebaseUtil.ObjectToRef(
        COLLECTION_USERS,
        cmt.createdBy.uid,
      );
      cmtObj.text = cmt.text;
      postCmts.push(cmtObj);
    });
    postObj.comments = postCmts;
    if (!post.likes.find((like: any) => like.uid === this.currentUser.uid)) {
      const like = {
        uid: this.currentUser.uid,
      };
      postObj.likes.push(like);
    }
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: post.id,
      payload: postObj,
    });
    this.$store.dispatch('addToCollection', {
      collection: COLLECTION_NOTIFICATIONS,
      payload: { ...this.parsedNotification(post) },
    });
    this.editedIndex = 0;
  }

  parsedNotification(post: any) {
    const notiObj = new Notification();
    notiObj.type = { ...NotificationType.like };
    notiObj.initiatedBy = FirebaseUtil.ObjectToRef(
      COLLECTION_USERS,
      this.currentUser.uid,
    );
    notiObj.to = FirebaseUtil.ObjectToRef(
      COLLECTION_USERS,
      post.createdBy.uid,
    );
    notiObj.data = FirebaseUtil.ObjectToRef(
      COLLECTION_POSTS,
      post.id,
    );
    return notiObj;
  }

  disLikePost(post: any) {
    const index = post.likes.findIndex((like: any) => like.uid === this.currentUser.uid);
    post.likes.splice(index, 1);
    const postObj = Post.convertToObj(post);
    postObj.id = post.id;
    postObj.createdBy = FirebaseUtil.ObjectToRef(
      COLLECTION_USERS,
      post.createdBy.uid,
    );
    const postCmts = [] as any;
    post.comments.forEach((cmt: any) => {
      const cmtObj = { ...cmt };
      cmtObj.createdTime = cmt.createdTime;
      cmtObj.createdBy = FirebaseUtil.ObjectToRef(
        COLLECTION_USERS,
        cmt.createdBy.uid,
      );
      cmtObj.text = cmt.text;
      postCmts.push(cmtObj);
    });
    postObj.comments = postCmts;
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: post.id,
      payload: postObj,
    });
    this.editedIndex = -1;
  }

  viewComment(post: any) {
    if (post.comments.length) {
      this.showComments.push(post.id);
    }
  }

  hideComments(id: any) {
    const index = this.showComments.findIndex((cmtid: any) => cmtid === id);
    this.showComments.splice(index, 1);
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  get freshCurrentUser() {
    return this.$store.state.freshCurrentUser;
  }

  get postView() {
    return this.$store.state.homePagePost;
  }

  get homeOrgPosts() {
    return this.$store.state.homePageOrgPosts;
  }

  showPostDetail(id: any) {
    this.$router.push(`/post/${id}`);
  }

  formatTime = (time: any) => {
    const date = new Date(time.seconds * 1000);
    return moment(date).fromNow();
    // return `${date.getHours()}:${date.getMinutes()}`;
  };
}
